module.exports = __webpack_public_path__ + "files/df8a048ddd79927beef259c899afdfa8.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Ubuntu-regular.woff
 ** module id = 880
 ** module chunks = 0
 **/